import type { YufaRecorder } from "./lianxi-yufa-recorder.js";

/** Offer feedback during practice as well as after completion. */
export function wireYufaComment(
  block: HTMLElement,
  recorder: YufaRecorder | undefined,
): void {
  const form = block.querySelector<HTMLFormElement>("[data-cb-yufa-comment]");
  const field = form?.querySelector<HTMLTextAreaElement>("textarea");
  const button = form?.querySelector<HTMLElement & { disabled: boolean }>(
    "button, wa-button",
  );
  const status = form?.querySelector<HTMLElement>("[role=status]");
  if (!form || !field || !button || !status || !recorder) {
    return;
  }
  const disclosure = form.closest<HTMLDetailsElement>("details");
  if (disclosure) {
    block.closest("article.lianxi, .cb-lianxi-page")?.append(disclosure);
    disclosure.hidden = false;
  }
  form.hidden = false;
  if (recorder.commented) {
    field.readOnly = true;
    button.disabled = true;
    status.textContent = "A comment is already saved for this sitting.";
  }
  let generation = 0;
  block.querySelector("[data-cb-yufa-again]")?.addEventListener("click", () => {
    generation++;
    field.value = "";
    field.readOnly = false;
    button.disabled = false;
    status.textContent = "";
  });
  form.addEventListener("submit", (event) => {
    event.preventDefault();
    const comment = field.value.trim();
    if (comment === "" || comment.length > 500 || button.disabled) {
      return;
    }
    button.disabled = true;
    const sent = generation;
    void recorder.comment(comment).then((saved) => {
      if (sent !== generation) {
        return;
      }
      status.textContent = saved
        ? "Your comment has been saved. Thank you."
        : recorder.commented
          ? "A comment is already saved for this sitting. Your text was not saved."
          : "Your comment could not be saved. Please try again.";
      field.readOnly = saved || recorder.commented;
      button.disabled = saved || recorder.commented;
    });
  });
}
